import { ButtonSplit } from "@nova/ds-component-button-split"
import { EventCategory } from "@nova/schemas"
import { RefObject } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectAppliedFilters, removeAppliedCategory, removeAppliedPeople } from "../slice"
import { categoryLabels } from "./filterLabels"
import { ActivityFilterMenuRef } from "./ActivityFilterMenu"

export const ActiveFilterPills = ({
    menuRef,
}: {
    menuRef: RefObject<ActivityFilterMenuRef | null>
}) => {
    const dispatch = useAppDispatch()
    const applied = useAppSelector(selectAppliedFilters)

    const categories = Object.keys(applied.categories) as EventCategory[]

    if (applied.people.length === 0 && categories.length === 0) return null

    return (
        <div className="flex items-center gap-2">
            {applied.people.length > 0 && (
                <ButtonSplit
                    label={`People · ${applied.people.length}`}
                    onLeftClick={() => menuRef.current?.openTo({ name: "people" })}
                    onRightClick={(e) => {
                        e.stopPropagation()
                        dispatch(removeAppliedPeople())
                    }}
                />
            )}
            {categories.map((category) => (
                <ButtonSplit
                    key={category}
                    label={categoryLabels[category]}
                    onLeftClick={() => menuRef.current?.openTo({ name: "category", category })}
                    onRightClick={(e) => {
                        e.stopPropagation()
                        dispatch(removeAppliedCategory(category))
                    }}
                />
            ))}
        </div>
    )
}
